import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=08d75dcc&"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js&"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports